import { useState } from "react";
import Select from "react-select";
import { TableViewDialog, TableDialogFooter, TableDialogBtn } from "../style";
import { OptionImage } from "../../product/style";

const ModulePropertyDialog = ({
  orderItem,
  access,
  tableManager,
  moduleColorIdentifiers,
  updateModuleProperties,
  toggleClearOverrideModal,
  setClearOverrideFunc,
  clearModuleOverrides,
  mutateCurrentRoom,
  isAdmin,
}) => {
  const [addPropertyList, setAddPropertyList] = useState([]);
  const [showAddProperty, setShowAddProperty] = useState(true);

  // FILTER valid properties
  const filteredProperties = orderItem.property_list.filter(
    (property) =>
      !moduleColorIdentifiers.includes(property.identifier) &&
      !property.is_overridden_v2 &&
      !property.is_automated &&
      !property.can_skip &&
      (isAdmin
        ? property.admin_property === true
        : property.admin_property !== true)
  );

  // GROUP by level
  const groupedOptions = [
    {
      label: "Module",
      options: filteredProperties
        .filter((prop) => prop.level === "module")
        .map((e) => ({
          label: e.name,
          value: e.identifier,
        })),
    },
    {
      label: "Module Advanced",
      options: filteredProperties
        .filter((prop) => prop.level === "module_advanced")
        .map((e) => ({
          label: e.name,
          value: e.identifier,
        })),
    },
    {
      label: "Section",
      options: filteredProperties
        .filter((prop) => prop.level === "section")
        .map((e) => ({
          label: e.name,
          value: e.identifier,
        })),
    },
    {
      label: "Section Advanced",
      options: filteredProperties
        .filter((prop) => prop.level === "section_advanced")
        .map((e) => ({
          label: e.name,
          value: e.identifier,
        })),
    },
    {
      label: "Project",
      options: filteredProperties
        .filter((prop) => prop.level === "project")
        .map((e) => ({
          label: e.name,
          value: e.identifier,
        })),
    },
    {
      label: "",
      options: filteredProperties
        .filter((prop) => prop.level === "admin")
        .map((e) => ({
          label: e.name,
          value: e.identifier,
        })),
    },
  ];

  const formatGroupLabel = (data) => (
    <>
      <div
        style={{
          padding: "0px",
        }}
      >
        {data.label}
      </div>
    </>
  );

  return (
    <TableViewDialog onClick={(e) => e.stopPropagation()}>
      <div className="d-flex flex-column row-gap-3">
        {orderItem.property_list
          .filter((property) =>
            [
              "module",
              "module_advanced",
              "section",
              "section_advanced",
              "project",
            ].includes(property.level)
          )
          .map((property, index) => {
            if (
              moduleColorIdentifiers.includes(property.identifier) ||
              !property.is_overridden_v2
            )
              return;

            return (
              <div
                className={`${property.highlight ? "highlight_property" : ""}`}
              >
                <p className="grey_letter mb-1">{property.name}</p>
                <div className="column-gap-3 d-flex align-items-center">
                  {property.is_editable ? (
                    <>
                      <Select
                        autoFocus={index === 0 ? true : false}
                        className="list-summary-select"
                        key={index}
                        isDisabled={!property.is_editable}
                        value={
                          property.options.find(
                            (option) =>
                              option.selected && property.is_overridden_v2
                          ) || null
                        }
                        onChange={(selectedOption) => {
                          property.is_overridden_v2 = true;
                          property.options.forEach((o) => {
                            o.selected =
                              o.identifier == selectedOption.identifier;
                          });
                          mutateCurrentRoom();
                          updateModuleProperties({
                            id: orderItem.id,
                            propIdentifier: property.uniq_id,
                            optionIdentifier: selectedOption.identifier,
                          });
                        }}
                        options={property.options.map((option, optionIndex) => {
                          option.value = option.name;
                          option.label = (
                            <div key={optionIndex}>
                              {option.image && (
                                <OptionImage
                                  src={option.image}
                                  alt={option.name}
                                  className="border border-dark rounded-circle me-2"
                                />
                              )}
                              {option.name}
                            </div>
                          );
                          option.isDisabled =
                            option.settings_disabled === true ||
                            option.settings_disabled === "true";
                          option.key = index;

                          return {
                            value: option.name,
                            label: option.name,
                            ...option,
                          };
                        })}
                      />
                      {property.is_clearable && property.is_editable && (
                        <i
                          className="fa-regular fa-trash-can fs-6 pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleClearOverrideModal();
                            setClearOverrideFunc(() => () => {
                              property.value_name = property.project_value_name;
                              property.is_overridden_v2 = false;
                              clearModuleOverrides({
                                id: orderItem.id,
                                propIdentifier: property.uniq_id,
                              });
                            });
                          }}
                        />
                      )}
                    </>
                  ) : (
                    <div className="mt-1 text-disabled">
                      {property.options.find((option) => option.selected)
                        ?.name || "No Value"}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
      </div>
      {addPropertyList.length > 0 && (
        <div className="mt-3 d-flex flex-column row-gap-3">
          {addPropertyList.map((identifier, index) => {
            const property = orderItem.property_list.find(
              (e) => e.identifier === identifier
            );

            return (
              <div key={index}>
                <p className="grey_letter mb-1">{property.name}</p>
                {property.is_editable ? (
                  <Select
                    // autoFocus={
                    //   index === addPropertyList.length - 1 ? true : false
                    // }
                    className="list-summary-select"
                    value={null}
                    isDisabled={!property.is_editable}
                    onChange={(selectedOption) => {
                      property.is_overridden_v2 = true;
                      property.options.forEach((o) => {
                        o.selected = o.identifier == selectedOption.value;
                      });
                      property.highlight = true;
                      setAddPropertyList(
                        addPropertyList.filter((e) => e !== identifier)
                      );
                      setShowAddProperty(true);
                      updateModuleProperties({
                        id: orderItem.id,
                        propIdentifier: property.uniq_id,
                        optionIdentifier: selectedOption.value,
                      });
                    }}
                    options={property.options.map((option) => ({
                      label: option.name,
                      value: option.identifier,
                      isDisabled:
                        option.settings_disabled === true ||
                        option.settings_disabled === "true",
                    }))}
                  />
                ) : (
                  <div className="mt-1 text-disabled">
                    {property.options.find((option) => option.selected)?.name ||
                      "No Value"}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
      <div className={`${addPropertyList.length === 0 ? "mt-3" : ""}`}>
        {showAddProperty && addPropertyList.length === 0 ? (
          orderItem.property_list.filter(
            (property) =>
              [
                "module",
                "module_advanced",
                "section",
                "section_advanced",
                "project",
              ].includes(property.level) &&
              !moduleColorIdentifiers.includes(property.identifier) &&
              property.is_overridden_v2
          ).length === 0 ? (
            <div className="d-flex flex-column align-items-center">
              <p className="mb-2">No customizations found.</p>
              <TableDialogBtn
                color={"#2c92e6"}
                border={"#2c92e6 !important"}
                onClick={(e) => {
                  e.stopPropagation(), setShowAddProperty(false);
                }}
              >
                Customize
              </TableDialogBtn>
            </div>
          ) : (
            showAddProperty && (
              <div
                className="d-flex align-items-center column-gap-2 active-dimension pointer"
                onClick={(e) => {
                  setShowAddProperty(false), e.stopPropagation();
                }}
              >
                <i className="fa-solid fa-plus" />
                <p className="m-0">Add Property</p>
              </div>
            )
          )
        ) : (
          addPropertyList.length === 0 && (
            <div className="d-flex align-items-center column-gap-2 position-relative">
              <Select
                placeholder={"Select Property"}
                className="list-summary-select"
                defaultValue={null}
                menuPosition="absolute"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                isDisabled={!access.customize_section || orderItem.is_filler}
                options={groupedOptions}
                formatGroupLabel={formatGroupLabel}
                onChange={(selectedOption) => {
                  setAddPropertyList([
                    ...addPropertyList,
                    selectedOption.value,
                  ]);
                  setShowAddProperty(true);
                }}
              />
              <p
                className="m-0 active-dimension pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowAddProperty(true);
                }}
              >
                Cancel
              </p>
            </div>
          )
        )}
      </div>
      <TableDialogFooter>
        <TableDialogBtn
          onClick={(e) => {
            e.stopPropagation();
            tableManager.clear();
          }}
          className="mt-3"
        >
          Done
        </TableDialogBtn>
      </TableDialogFooter>
    </TableViewDialog>
  );
};

export default ModulePropertyDialog;
